// import React, { PureComponent } from 'react';
/* eslint-disable jsx-a11y/label-has-associated-control */
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import Button from '../../button/Button';
import { useTheme } from '../../theme-context';
import './manage-dashboard-footer.scss';

interface IManageDashboardFooterParams {
    disabled: boolean;
    getTicketsAction: () => void;
    legendAction: () => void;
    info: {
        getTicketsLabel: GenericLazyString;
    };
    printAction: () => void;
}

const ManageDashboardFooter = ({
    disabled,
    getTicketsAction,
    info,
    legendAction,
    printAction,
}: IManageDashboardFooterParams) => {
    const { getTicketsLabel } = info;
    const { getFont, styles } = useTheme();
    return (
        <div
            className={css({
                width: '100%',
                fontFamily: getFont('desktop/body/large').fontFamily,
                backgroundColor: styles.colors['brand-white'].color,
            })}
        >
            <div
                data-testid="legend-button"
                className={css({
                    float: 'left',
                    margin: '16px 12px 16px 24px',
                })}
            >
                <Button onClick={legendAction}>{gettext('Legend')}</Button>
            </div>
            <div
                data-testid="print-button"
                className={css({
                    float: 'left',
                    margin: '16px 24px 16px 12px',
                })}
            >
                <Button onClick={printAction}>{gettext('Print')}</Button>
            </div>
            <div className="get-tickets">
                <div
                    data-testid="get-tickets-button"
                    className={css({
                        float: 'right',
                        margin: '16px 24px 16px 24px',
                    })}
                >
                    <Button
                        disabled={disabled}
                        style="fill"
                        onClick={getTicketsAction}
                    >
                        {getTicketsLabel}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ManageDashboardFooter;
